import * as React from 'react';
import {useCallback, useEffect} from 'react';
import {connect} from 'react-redux';
import {StoreState} from '../../App/initialStore';
import * as _ from 'lodash';
import {removeAllImagesFromBar} from '../../MyAccount/ViewDesigns/redux/modules/images';
import UploadImageStatusBar, {UploadImageStatusBarProps} from './UploadImageStatusBar';

export interface ConnectedUploadImageStatusBarProps extends Partial<UploadImageStatusBarProps> {
  resourceType: string;
  removeAllImagesFromBar?: typeof removeAllImagesFromBar;
}

function ConnectedUploadImageStatusBar({
  resourceType,
  removeAllImagesFromBar,
  uploadedImages,
  ...props
}: ConnectedUploadImageStatusBarProps) {
  const handleRemoveAll = useCallback(() => removeAllImagesFromBar({resourceType}), [removeAllImagesFromBar]);
  const handleCancelUpload = useCallback(image => {
    if (_.isFunction(image.cancelUpload)) {
      image.cancelUpload();
    }
  }, []);
  const handleRetryUpload = useCallback(image => {
    if (_.isFunction(image.retryUpload)) {
      image.retryUpload();
    }
  }, []);
  useEffect(() => {
    handleRemoveAll();
  }, [resourceType]);
  return (
    <UploadImageStatusBar
      actionBarMargin={64}
      removeAll={handleRemoveAll}
      cancelUpload={handleCancelUpload}
      retryUpload={handleRetryUpload}
      uploadedImages={uploadedImages}
      fixedPosition
      {...props}
    />
  );
}

export default connect(
  (state: StoreState, {resourceType}: ConnectedUploadImageStatusBarProps) => ({
    uploadedImages: state.images[resourceType].uploadFiles,
  }),
  {removeAllImagesFromBar}
)(ConnectedUploadImageStatusBar);
